import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY, COLUMN_HALERVYROV_PRP } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			[COLUMN_HALERVYROV_PRP]: { isEditable: true },
		},
	},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
